import './CampainBox.scss';

const CampainBox = ({ icon, title, subtitle, handleClick }) => {
  return (
    <div className="campains__box" onClick={handleClick && handleClick}>
      <img src={icon} alt={title}/>
      <p className="source-20 mb-10 mt-10">{title}</p>
      <p className="source-16">{subtitle}</p>
    </div>
  );
};

export default CampainBox;
